import ReactPlayer from 'react-player'
import React, { useState, useEffect, Fragment } from 'react'

const Player = ({
  className,
  width = '100%',
  height = '100%',
  videoUrl,
  isPlaying = false,
  showControls = true,
  shouldMute = true,
  playInline,
  volume = 0,
  loop = false,
  volumeUpWhenPlayed = false,
  style = {},
}) => {
  const [isMuted, setIsMuted] = useState(shouldMute)
  const [volumeUp, setVolumeUp] = useState(volume)

  return (
    <>
      {videoUrl ? (
        <ReactPlayer
          style={{
            pointerEvents: showControls ? 'all' : 'none',
            ...style
          }}
          className={className ? className : 'absolute top-0 left-0 videoplayer'}
          url={videoUrl}
          width={width}
          height={height}
          loop={loop}
          playing={isPlaying}
          controls={showControls}
          playsinline={playInline}
          muted={isMuted}
          volume={volumeUp}
          onProgress={(progress) => {
            if (progress.playedSeconds > 1 && volumeUpWhenPlayed) {
              setIsMuted(false)
              setVolumeUp(1)
            }
          }}
          config={{ vimeo: { playerOptions: { controls: showControls } } }}
        />
      ) : (
        <div></div>
      )}
    </>
  )
}

export default Player
